var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"env-monitoring"},[_c('div',{staticClass:"page-main"},[_c('iframe',{attrs:{"id":"iframeBox","name":"iframeBox","seamless":"","scrolling":"no","src":_vm.iframeUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }